import gql from 'graphql-tag';

const query = gql`
  query Settings {
    me {
      id
      systemOfMeasures
    }
  }
`;

export default query;
